import { defineComponent as c, ref as u, computed as p, openBlock as l, createElementBlock as a, normalizeClass as m, createElementVNode as y, renderSlot as k, toRef as S, resolveComponent as C, Fragment as h, renderList as v, createBlock as b, withModifiers as $, withCtx as x, createTextVNode as V, toDisplayString as z } from "vue";
import { useProxyModelValue as _ } from "@onereach/ui-components-common/hooks";
import { _ as f } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const M = [
  // Layout
  "layout-row justify-center",
  // Shape
  "rounded-md",
  // Interactivity
  "interactivity-click",
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark",
  // Theme (selected)
  "selected:theme-background-default",
  "dark:selected:theme-background-default-dark",
  // Theme (selected, enabled)
  "selected:enabled:shadow-card",
  "dark:selected:enabled:shadow-card-dark"
], O = {
  m: [
    // Box
    "h-[44px] md:h-[36px]",
    // Spacing
    "px-sm+ md:px-sm+",
    // Typography
    "typography-body-2-regular"
  ],
  s: [
    // Box
    "h-[36px] md:h-[32px]",
    // Spacing
    "px-sm+ md:px-sm",
    // Typography
    "typography-caption-regular"
  ]
}, w = c({
  name: "OrSegmentedControlItem",
  props: {
    size: {
      type: String,
      required: !0
    },
    selected: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, t) {
    const o = u(), r = p(() => [
      "or-segmented-control-item-v3",
      ...M,
      ...O[e.size]
    ]);
    function d(i) {
    }
    return {
      root: o,
      rootStyles: r,
      onClick: d
    };
  }
}), B = ["selected", "disabled"], I = {
  class: /* @__PURE__ */ m(["truncate"])
};
function R(e, t, o, r, d, i) {
  return l(), a("div", {
    ref: "root",
    class: m(e.rootStyles),
    selected: e.selected,
    disabled: e.disabled,
    onClick: t[0] || (t[0] = (...s) => e.onClick && e.onClick(...s))
  }, [
    y("div", I, [
      k(e.$slots, "default")
    ])
  ], 10, B);
}
const E = /* @__PURE__ */ f(w, [["render", R]]);
var g = /* @__PURE__ */ ((e) => (e.M = "m", e.S = "s", e))(g || {});
const N = [
  // Layout
  "grid",
  "grid-flow-col",
  "auto-cols-fr",
  // Shape
  "rounded-md",
  // Spacing
  "px-[2px]",
  "py-[2px]",
  // Theme
  "theme-background-surface-variant",
  "dark:theme-background-surface-variant-dark"
], j = {
  m: [],
  s: []
}, q = c({
  name: "OrSegmentedControl",
  components: {
    OrSegmentedControlItem: E
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: () => g.M
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue"
  ],
  expose: [
    "root"
  ],
  setup(e, t) {
    const o = u(), r = p(() => [
      "or-segmented-control-v3",
      ...N,
      ...j[e.size]
    ]), d = _(S(e, "modelValue"), t.emit);
    return {
      root: o,
      rootStyles: r,
      proxyModelValue: d
    };
  }
});
function A(e, t, o, r, d, i) {
  const s = C("OrSegmentedControlItem");
  return l(), a("div", {
    ref: "root",
    class: m(e.rootStyles)
  }, [
    (l(!0), a(h, null, v(e.options, (n) => (l(), b(s, {
      key: n.value,
      size: e.size,
      selected: n.value === e.proxyModelValue,
      disabled: e.disabled,
      onClick: $((D) => e.proxyModelValue = n.value, ["stop"])
    }, {
      default: x(() => [
        V(z(n.label), 1)
      ]),
      _: 2
    }, 1032, ["size", "selected", "disabled", "onClick"]))), 128))
  ], 2);
}
const T = /* @__PURE__ */ f(q, [["render", A]]);
export {
  T as O,
  g as S
};
//# sourceMappingURL=OrSegmentedControl-D5QoWe-N.mjs.map
